module.exports = __webpack_public_path__ + "img/user-img.8e00d644.svg";